var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaoCategoryLift = function SvgDaoCategoryLift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.258,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105643",
    d: "M5.796 16.18a.974.974 0 0 1 .192-.509c-1.077-1.4-4.264-4.835-5.554-9.207.001 0-2.701 4.04 5.362 9.716Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105644",
    d: "M7.007 15.038C2.551 5.192 4.127 1.712 4.127 1.712 3.19 1.79.885 3.328 1.034 5.44c.252 3.626 4.024 8.523 5.216 9.988a2.562 2.562 0 0 1 .757-.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105645",
    d: "M8.625 14.787c.1 0 .191 0 .286.007.222-3.228.634-11.229.414-13.443-.234-2.345-3.81-1.2-4.357.156-1.544 3.837 1.518 11.4 2.4 13.423a5.419 5.419 0 0 1 1.257-.143Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105646",
    d: "M9.286 14.826a4.828 4.828 0 0 1 .782.154c1.839-3.685 3.348-8.516 3.061-11.753A3 3 0 0 0 9.982.492c.41 4.139-.436 12.076-.696 14.334Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105647",
    d: "M13.825 2.783c.46 4.648-2.405 10.587-3.324 12.351a2.089 2.089 0 0 1 .621.4c1.807-2.565 4.213-5.412 4.847-8.83a3.59 3.59 0 0 0-2.144-3.921Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105648",
    d: "M16.52 6.464c-.259 3.375-3.766 7.689-5.188 9.312a.943.943 0 0 1 .1.248c8.683-5.271 5.088-9.56 5.088-9.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105649",
    d: "M8.625 15.158c-1.34 0-2.427.483-2.427 1.083a2.724 2.724 0 0 0 .187 1.064 2.2 2.2 0 0 0 .143.316.8.8 0 0 1 .127-.166 1.535 1.535 0 0 1 .49-.309 3.914 3.914 0 0 1 1.481-.261 4.285 4.285 0 0 1 1.164.151 1.882 1.882 0 0 1 .807.419.822.822 0 0 1 .129.168 2.265 2.265 0 0 0 .142-.316 2.73 2.73 0 0 0 .188-1.064c-.003-.6-1.089-1.085-2.431-1.085Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105650",
    d: "M8.643 17.213c-1.028 0-1.862.247-1.862.552s.834.552 1.862.552 1.862-.247 1.862-.552-.834-.552-1.862-.552Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105651",
    d: "M9.145 19.064a11.863 11.863 0 0 0-1.518-.426c-.16-.017-.422.021-.422.334s.262 1.062 1.7 1.028c.614-.014.961-.155 1.042-.345s-.056-.28-.802-.591Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105652",
    d: "m8.368 18.704 1.362.446s.329.1.414-.115.1-.448-.257-.471-2.358-.135-1.519.14Z"
  })));
};
export default SvgDaoCategoryLift;